import React from 'react'
import Nav from "../../components/Nav";
import navItems from "../../components/Nav/index.json";
import "./index.css"
import subnavItems from "./index.json";

function Adhesions() {

    return (
        <>
            <Nav items={navItems.urls} />
                <div className="Adhesions-Core">
                <Nav items={subnavItems.urls} sub />
                
                <div className="Adhesions Adhesions-Intro" id="musculation-halterophilie">
                    <p className="Adhesions-Title">Musculation-Haltérophilie</p>
                    <p className="Adhesions-Text">
                    <div className="Adhesions-Left">
                            Lundi au vendredi : <strong>17h-21h30</strong><br />
                            Samedi: <strong>10h30-12h30 & 16h à 19h30</strong><br />
                        </div>
                        <div className="Adhesions-Right Adhesions-RightTrue">
                            <strong className="Adhesions-subtitle">Séances en autonomie ou avec suivi sportif encadré par un éducateur :</strong> <br />
                            Nouvel adhérent : <strong>210€</strong><br />
                            Ancien adhérent : <strong>180€</strong><br /><br />
                            Séance d’essai en autonomie <strong>5€</strong><br /><br />
                            <strong className="Adhesions-subtitle">Accompagnement avec un éducateur
                            1 fois/semaine :</strong><br />
                            + 90€ sur toute la saison sportive<br />
                            <strong className="Adhesions-subtitle">Suivi sportif 1 fois/semaine :</strong><br />
                            + 250€ le trimestre<br />
                            
                            <strong className="Adhesions-subtitle">Coaching individuel (réservé aux adhérent.e.s) :</strong> <br />
                            5 séances de 60 minutes chacun :  <strong>200€ </strong>ou à l’unité <strong>50€/h</strong><br />
                    </div>
                    </p>
                </div>

                <div className="Adhesions Adhesions-Intro" id="ordonnance">
                    <p className="Adhesions-Title">Sport-Santé sur ordonnance pour femmes : Cours collectifs</p>
                    <p className="Adhesions-Text">
                    <div className="Adhesions-Left">
                            Mercredi : <strong>18h à 19h</strong><br />
                        </div>
                        <div className="Adhesions-Right Adhesions-RightTrue">
                            Cours collectifs variés avec adaptations : <strong>100€ la saison sportive</strong> <br />
                            <span className="Adhesions-mention">Remboursement possible par certaines mutuelles de santé</span><br />
                            Ou : <strong>20€ le 1er trimestre</strong><br />
                            Première séance d’essai : <strong>gratuite sur RDV</strong>
                    </div>
                    </p>
                </div>

                <div className="Adhesions Adhesions-Intro" id="sport-sante">
                    <p className="Adhesions-Title">Muscu'Santé/Cardio</p>
                    <p className="Adhesions-Text">
                    <div className="Adhesions-Left">
                        Lundi au samedi : <strong>2 séances/semaine sur RDV</strong><br />
                        + 1 séance en autonomie selon le niveau<br />
                        </div>
                        <div className="Adhesions-Right Adhesions-RightTrue">
                            <strong className="Adhesions-subtitle">Séances adaptées avec coaches et bilans de forme :</strong><br />
                            Nouvel adhérent : <strong>300€</strong><br />
                            Ancien adhérent : <strong>270€</strong><br />
                            <span className="Adhesions-mention">Remboursement possible par certaines mutuelles de santé</span><br /><br />
                            Bilans conditions physiques inclus avec entretien motivationnel.<br />
                            Première séance d’essai sur RDV : <strong>5€</strong>. Les suivantes : <strong>15€</strong>.
                    </div>
                    </p>
                </div>

                <div className="Adhesions Adhesions-Intro" id="musculation-seniors">
                    <p className="Adhesions-Title">Muscu'Seniors</p>
                    <p className="Adhesions-Text">
                    <div className="Adhesions-Left">
                        Mercredi : <strong>17h à 18h</strong><br />
                        </div>
                        <div className="Adhesions-Right Adhesions-RightTrue">
                            Atelier de renforcement musculaire avec adaptations pour personnes de + de 55 ans :  <br /><strong>20€ le premier trimestre</strong><br />
                            ou<br />       
                            <strong>100€ la saison sportive</strong><br /> 
                            Première séance d’essai sur RDV : <strong>gratuite</strong>
                    </div>
                    </p>
                </div>

                <div className="Adhesions Adhesions-Intro" id="musculation-jeunes">
                    <p className="Adhesions-Title">Muscu'Jeunes</p>
                    <p className="Adhesions-Text">
                    <div className="Adhesions-Left Adhesions-LeftTrue">
                            Mardi & jeudi : <strong>19h à 20h</strong><br />
                            Samedi : <strong>16h-17h</strong><br /><br />
                            Cours collectifs de musculation encadrés avec adaptations pour mineurs de 12 à 17 ans.<br />
                            Conseils en santé et hygiène de vie. Prévention malbouffe et sédentarité.
                        </div>
                        <div className="Adhesions-Right"><strong>270€</strong><br />
                            <span className="Adhesions-mention">Réduction de -20% à -70% grâce aux coupons CCAS de la mairie de Créteil<br /> (sous conditions de revenus) <a href="https://www.ville-creteil.fr/prestations-sociales#sportetculture">(Ville de Créteil - Prestations sociales)</a></span><br />
                            Première séance d’essai sur RDV avec autorisation parentale : <strong>5€</strong>
                    </div>
                    </p>
                </div>

               <div className="Adhesions Adhesions-Intro" id="posture-sante">
                    <p className="Adhesions-Title">Posture Santé</p>
                    <p className="Adhesions-Text">
                    <div className="Adhesions-Left">
                            Samedi: <strong>17h à 18h</strong><br />
                        </div>
                        <div className="Adhesions-Right Adhesions-RightTrue">
                            <strong>100€ la saison sportive</strong><br />
                            Séance d’essai sur RDV : <strong>5€</strong>
                    </div>
                    </p>
                </div>
 {/*
                <div className="Adhesions Adhesions-Intro" id="cross-training">
                    <p className="Adhesions-Title">Cross-Training</p>
                    <div className="Adhesions-Text Adhesions-LastText">
                        <div className="Adhesions-Left Adhesions-LeftTrue">
                            Lundi & vendredi : <strong>19h à 20h</strong> (en extérieur)<br />
                            Mercredi : <strong>17h-18h30</strong> (en intérieur)<br />
                            Samedi & dimanche : <strong>9h30-10h30</strong> (en extérieur)<br /><br />
                            Cours collectifs de cross-training en extérieur et en intérieur. <br />Adaptations possibles selon niveaux de pratique.
                        </div>
                        <div className="Adhesions-Right">
                            (tarif unique semaine et week-end)<br />
                            Anciens adhérents : <strong>290€</strong> <br />
                            Nouveaux adhérents : <strong>320€</strong> <br />
                            
                            Formule tout compris + salle musculation : <strong>420€</strong> (390€ anciens adhérents)<br />
                            Séance d’essai sur réservation : <strong>5€</strong>
                        </div>
                    </div>
                </div>*/}

            </div>
        </>
    );
}

export default Adhesions